import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import type { ReactNode } from "react";

interface BezonedConfirmDialogProps {
  cancelLabel?: string;
  confirmLabel?: string;
  content: ReactNode;
  isConfirming?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  open: boolean;
  title: string;
}

export const BezonedConfirmDialog = ({
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  content,
  isConfirming = false,
  onCancel,
  onConfirm,
  open,
  title,
}: BezonedConfirmDialogProps) => {
  const handleOpenChange43 = useStableCallback((_event, data) => {
    if (!(data.open || isConfirming)) {
      onCancel();
    }
  });

  if (!(open || isConfirming)) {
    return null;
  }

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Dialog onOpenChange={handleOpenChange43} open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>{content}</DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isConfirming}
              onClick={onCancel}
              type="button"
            >
              {cancelLabel}
            </Button>
            <Button
              appearance="primary"
              disabled={isConfirming}
              onClick={handleConfirm}
              type="button"
            >
              {confirmLabel}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
